
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppContextMenuOption extends Vue {
    @Prop() private value!: string
    @Prop({ default: false }) private highlight!: boolean

    get color() {
        return this.highlight ? '#FF0000' : '#212121'
    }

    @Emit('click')
    public onClick(event: Event) {
        event.stopPropagation()
        return event
    }
}
